import React from 'react'
import './SmallSpinner.scss'

export const SmallSpinner = () => {
  return (
    <div className='loading_page_small'>
      <div className='spinner_small'>
        <span className='loader_small' />
      </div>
    </div>
  )
}